<template>
  <v-icon :icon="icon" :color="color" :size="size">
    <slot />
  </v-icon>
</template>

<script setup lang="ts">
defineProps({
  icon: { type: String, default: undefined },
  color: { type: String, default: undefined },
  size: { type: [String, Number], default: undefined },
});
</script>
